import { useEffect } from 'react';
import {
  type AnnotoriousOpenSeadragonAnnotator,
  type ImageAnnotation,
  useAnnotator,
} from '@annotorious/react';

interface UseAnnotationBridgeProps {
  annotations?: Array<ImageAnnotation>;
  onAnnotationsChange?: (annotations: Array<ImageAnnotation>) => void;
}

export const useAnnotationsBridge = ({
  annotations,
  onAnnotationsChange,
}: UseAnnotationBridgeProps) => {
  const seadragonAnnotator = useAnnotator<
    AnnotoriousOpenSeadragonAnnotator | undefined
  >();

  useEffect(() => {
    if (!seadragonAnnotator || !annotations) return;
    seadragonAnnotator.setAnnotations(annotations, true);
  }, [seadragonAnnotator, annotations]);

  useEffect(() => {
    if (!seadragonAnnotator || !onAnnotationsChange) return;
    const emit = () => {
      onAnnotationsChange(seadragonAnnotator.getAnnotations());
    };
    seadragonAnnotator.on('createAnnotation', emit);
    seadragonAnnotator.on('deleteAnnotation', emit);
    seadragonAnnotator.on('updateAnnotation', emit);
    return () => {
      seadragonAnnotator.off('createAnnotation', emit);
      seadragonAnnotator.off('deleteAnnotation', emit);
      seadragonAnnotator.off('updateAnnotation', emit);
    };
  }, [seadragonAnnotator, onAnnotationsChange]);
};
